import { HelperResult, PhoneNumber } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: usePhoneNumber,
  useUpdate: useUpdatePhoneNumber,
  useDelete: useDeletePhoneNumber,
} = getCRUDHooks({
  entityName: 'phoneNumber',
  get: ({ userId }: { userId: number }): HelperResult<PhoneNumber> =>
    clientApi.getOCClient().helpers.user.users.id(userId).phoneNumber.get(),
  update: (
    values: PhoneNumber,
    { userId, context }: { userId: number; context: string }
  ): HelperResult<PhoneNumber> =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .phoneNumber.update('', values, false)
      .setHeader('X-Request-Context', context)
      .execute(),
  remove: ({ userId }: { userId: number }): HelperResult<void> =>
    clientApi.getOCClient().helpers.user.users.id(userId).phoneNumber.delete(),
});

export { usePhoneNumber, useUpdatePhoneNumber, useDeletePhoneNumber };
